// extracted by css-extract-rspack-plugin
export default {"pagination":"ObjectDetailWrapper-module__pagination___G3fF_"};